const registerModule = {
    title1: "给您登录的手机号码发送4位验证码",
    title2: "验证码将通过短信发送",
    register: "注册",
    nextStep: "下一步",
    areaCodeTitle: "手机区号选择",
    resendText: "*后可再次发送验证码",
    codePrompt: "请输入您收到的四位数验证码",
    setPassword: "设置密码",
    sendCodeText: "我们将向上述手机号发送短信验证码。受通讯情况影响，收信时间可能会有延迟。",
    isPhone: "请填写手机号",
    sendCodeAgain: "再次发送短信至*",
    sendSuccess: "发送成功",
    passwordHint: "请输入6-32位的半角英文或数字",
    isPassword: "密码不能为空",
    samePassword: "两次密码不相同",
    registerSuccess: "注册成功",
    forgetPwTitle: "忘记密码",
    newPassword: "新密码",
    restSuccess: "修改成功",
    sendCode: "获取验证码",
    requiredEmail: '请填写邮箱',
    phoneError: "手机号格式不正确",
};

export default registerModule;
